<div class="carousel-counter" *ngIf="isCounter">{{counter}}</div>

<div class="carousel-container" [class.carousel-moving]="isMoving">
  <div class="carousel-cells" #cells (transitionend)="handleTransitionendCellContainer($event)">
    <ng-content></ng-content>

    <ng-template ngFor let-image [ngForOf]="images" let-i="index">
      <div class="carousel-cell"
           [style.width]="getCellWidth()+'px'"
           [style.border-radius]="borderRadius+'px'"
           *ngIf="i < cellLimit">
        <lib-carousel-media-cell
          [media]="getImage(i)"
          [allowDelete]="allowDelete"
          (action)="handleMediaCellAction($event)"
          [allowPrimaryTypes]="allowPrimaryCellsSelection ? allowPrimaryTypes : []"
          [isOwner]="isOwner"
          [isGalleryManager]="isGalleryManager"
        ></lib-carousel-media-cell>
      </div>
    </ng-template>
  </div>

  <div class="carousel-dots" *ngIf="dots">
    <div class="carousel-dot" [class.carousel-dot-active]="i === activeDotIndex" *ngFor="let dot of dotsArr; index as i"></div>
  </div>
</div>

<div class="carousel-arrows"
     [class.carousel-arrows-outside]="arrowsOutside"
     [class.carousel-dark-arrows]="arrowsTheme === 'dark'"
     *ngIf="isArrows">

  <div *ngIf="leftArrow === null" class="carousel-arrow carousel-arrow-prev" [class.carousel-arrow-disabled]="isPrevArrowDisabled()" (click)="prev()">
    <!-- <span class="material-icons"> arrow_back_ios </span> -->
    <i class="fa-light fa-chevron-left"></i>
  </div>
  <div *ngIf="leftArrow !== null" class="carousel-arrow carousel-arrow-prev" [style.left]="leftArrow+'px'" [class.carousel-arrow-disabled]="isPrevArrowDisabled()" (click)="prev()">
    <!-- <span class="material-icons"> arrow_back_ios </span> -->
    <i class="fa-light fa-chevron-left"></i>
  </div>
  <div *ngIf="rightArrow === null" class="carousel-arrow carousel-arrow-next" [class.carousel-arrow-disabled]="isNextArrowDisabled()" (click)="next()">
    <!-- <span class="material-icons"> arrow_forward_ios </span> -->
    <i class="fa-light fa-chevron-right"></i>
  </div>
  <div *ngIf="rightArrow !== null" class="carousel-arrow carousel-arrow-next" [style.right]="rightArrow+'px'" [class.carousel-arrow-disabled]="isNextArrowDisabled()" (click)="next()">
    <!-- <span class="material-icons"> arrow_forward_ios </span> -->
    <i class="fa-light fa-chevron-right"></i>
  </div>
</div>

<!-- (canplay)="($event)" -->
